const config = {
  kioskBaseUrl:
    process.env.VUE_APP_IS_STANDALONE === "true"
      ? process.env.VUE_APP_BASE_URL
      : window.location.origin + "/",
  token: null,
  selectedLocation: localStorage.getItem("selectedLocation")
};

export default config;
